import React, { useContext, useState } from 'react'
import AvatarMenu, { UserAvatarVisual } from './AvatarMenu'
import DemoSwitchButton from '../../demo/DemoSwitchButton'
import DemoSignUpButton from '../../demo/DemoSignUpButton'
import { TenantSettingsContext, UserContext } from '../../../App'
import { useNavigate } from 'react-router-dom'
import { useNavCounts } from '../NavCountsContext'
import QuickAdd from './QuickAdd'
import BaseLocationPicker from './BaseLocations'
import WhatsNewBadge from './WhatsNewBadge'
import NotificationBell from './NotificationBell'
import HelpButton from './HelpButton'
import {
  GlobalSearchBar,
  GlobalSearchDialog,
} from '../search/GlobalSearch'

//@MUI
import { Alert, styled } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate'
import Box from '@mui/material/Box'
import Badge from '@mui/material/Badge'
import Tooltip from '@mui/material/Tooltip'
import TimeDisplay from '../../../partials/Timers/TimerPopup/TimeDisplay'
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined'
import { Cake } from '@mui/icons-material'
// import BaseLocationPicker from './BaseLocations'

// Module scope on purpose: declaring a styled component inside the render
// body creates a brand-new component type on every Header render, so React
// unmounts and remounts everything under it (and drops any click in flight).
const TaskBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 12,
    padding: '0 4px',
    cursor: 'pointer',
    backgroundColor: theme.palette.contrast.main,
    color: theme.palette.contrast.contrastText,
  },
}))

const Header = ({ setSidebarState, toggleSidebarCollapsed }) => {
  const { user } = useContext(UserContext)
  const { tenantInfo } = useContext(TenantSettingsContext)
  const navigate = useNavigate()
  // Shared with the sidebar badges; replaces the old per-route
  // /my-tasks-count poll (same count definition server-side)
  const myTaskCount = useNavCounts().counts.myTasks ?? 0
  const [myTimeTrackers, setMyTimeTrackers] = useState([])

  // TODO
  // useEffect(() => {
  //   API.get('/my-active-time-trackers').then((res) => {
  //     if (res.status === 200) {
  //       console.log('TRACKERS', res.data)
  //       setMyTimeTrackers(res.data)
  //     }
  //   })
  // }, [])
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      bgcolor="background.paper"
      p={1}
      gap={2}
      alignItems="center"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <GlobalSearchDialog />
      <Box display={{ xs: 'flex', lg: 'none', gap: 5 }} alignItems="center">
        <MenuIcon
          sx={{ color: 'primary.main', cursor: 'pointer' }}
          onClick={() => {
            setSidebarState((prev) => ({ ...prev, mobileOpen: true }))
          }}
        />
        <QuickAdd />
      </Box>
      <Box display={{ xs: 'none', lg: 'flex', gap: 5 }} alignItems="center">
        <MenuIcon
          sx={{ color: 'primary.main', cursor: 'pointer' }}
          onClick={toggleSidebarCollapsed}
        />
        <QuickAdd />
      </Box>
      <Box
        flex={1}
        display={{ xs: 'none', lg: 'flex' }}
        justifyContent="center"
      >
        <GlobalSearchBar />
      </Box>
      <Box display="flex" gap={4}>
        {myTimeTrackers.length === 1 ? (
          <TimeDisplay activeTracker={myTimeTrackers[0]} />
        ) : (
          myTimeTrackers.length > 1 && (
            <TaskBadge badgeContent={myTimeTrackers.length} color="error">
              <TimerOutlinedIcon />
            </TaskBadge>
          )
        )}
        <BaseLocationPicker TaskBadge={TaskBadge} />
        <WhatsNewBadge TaskBadge={TaskBadge} />
        <HelpButton />
        <NotificationBell TaskBadge={TaskBadge} />
        {myTaskCount > 0 && (
          <Box display={{ xs: 'none', lg: 'flex' }}>
            <Tooltip title={myTaskCount + ' tasks'}>
              {/* onClick on the badge root, not the icon, so the count
                  bubble is part of the click target too */}
              <TaskBadge
                badgeContent={myTaskCount}
                color="contrast"
                onClick={() => navigate('/my-tasks')}
                sx={{ cursor: 'pointer' }}
              >
                <AssignmentLateIcon sx={{ color: 'primary.main' }} />
              </TaskBadge>
            </Tooltip>
          </Box>
        )}
        {/* Demo tenants swap the avatar menu for the prominent persona
            switcher plus an inert avatar of the current persona — switching
            (and leaving the demo) lives in the picker dialog. */}
        {tenantInfo?.isDemo ? (
          <Box display="flex" alignItems="center" gap={1.5}>
            <DemoSignUpButton />
            <DemoSwitchButton />
            <UserAvatarVisual user={user} />
          </Box>
        ) : (
          <AvatarMenu />
        )}
      </Box>
    </Box>
  )
}

export default Header
